import { SeoPageSchema } from 'cms/schemaTypes/generalSchemas/seo'

import { urlFor } from 'lib/sanity/image'

import PageMeta from './PageMeta'

interface Props {
  seo: Omit<SeoPageSchema, '_type'>
  path: string
}

export default function MetaHeadCMS({
  seo: { seoTitle, seoDescription, seoAsset },
  path
}: Props) {
  const imageUrl = seoAsset?.asset?.asset
    ? urlFor(seoAsset?.asset?.asset)?.url()
    : null

  return (
    <PageMeta
      title={seoTitle}
      description={seoDescription || ''}
      url={path}
      imageData={{
        alt: seoTitle || '',
        url: imageUrl || undefined
      }}
    />
    // <></>
  )
}
